import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { t } from 'i18next';

export function lockActionTitle(action: 'edit' | 'delete' | 'create', lockedByActionId?: string | null, customTitle?: string): ReactNode {
  if (!lockedByActionId) return customTitle ?? t(`enso.buttons.${action}`);
  const link = (
    <Link to={`/change-requests?search-change-requests=${encodeURIComponent(lockedByActionId ?? '')}`}>{lockedByActionId}</Link>
  );
  return (
    <>
      {t(`global.buttons.${action}LockedByChangeRequest`)}
      {link}
    </>
  );
}
